import type { Color } from '../types';

type Props = {
  result: { winner: Color | 'draw' | null; reason: string | null };
  onClose: () => void;
};

function resultText(winner: Color | 'draw' | null) {
  if (winner === 'w') return 'Победа белых';
  if (winner === 'b') return 'Победа чёрных';
  if (winner === 'draw') return 'Ничья';
  return 'Игра окончена';
}

export function GameOverModal({ result, onClose }: Props) {
  return (
    <div className="promotion-overlay">
      <div className="promotion-modal">
        <h2>{resultText(result.winner)}</h2>
        <p>{result.reason || ''}</p>
        <button className="primary full" onClick={onClose}>Понятно</button>
      </div>
    </div>
  );
}